export default "__VITE_ASSET__CvCJBZVG__"